// ============================================================
// FILE: src/pages/Testimonials.jsx
// ============================================================
import React from 'react';
import { motion } from 'framer-motion';
import TestimonialCard from '../componenets/TestomonialCard';

const Testimonials = () => {
    const testimonials = [
        { name: 'Rahul Sharma', role: 'Project Manager, ABC Corp', content: 'Exceptional quality and timely delivery. Sanwariya Ji exceeded our expectations on every front.', avatar: 'https://i.pravatar.cc/100?img=1' },
        { name: 'Priya Patel', role: 'Director, InfraBuild', content: 'Their expertise in steel fabrication is unmatched. Highly recommended for any industrial project.', avatar: 'https://i.pravatar.cc/100?img=5' },
        { name: 'Amit Singh', role: 'CEO, Metro Constructions', content: 'Professional team with great attention to detail. We look forward to working with them again.', avatar: 'https://i.pravatar.cc/100?img=3' },
        { name: 'Sneha Reddy', role: 'Operations Head, MegaSteel', content: 'Reliable, efficient, and always on time. A true partner in our success.', avatar: 'https://i.pravatar.cc/100?img=9' },
        { name: 'Vikram Joshi', role: 'Site Engineer, BuildRight', content: 'The quality of fabrication and welding is top-notch. Very satisfied with the outcome.', avatar: 'https://i.pravatar.cc/100?img=7' },
        { name: 'Ananya Mehta', role: 'Procurement Lead, IndusCorp', content: 'Great communication and transparency throughout the project. Highly professional.', avatar: 'https://i.pravatar.cc/100?img=2' },
    ];

    return (
        <div className="pt-24">
            <section className="section-padding">
                <div className="container-custom">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="text-center mb-12"
                    >
                        <h1 className="text-4xl md:text-5xl font-bold">Client <span className="gradient-text">Testimonials</span></h1>
                        <p className="text-gray-400 mt-2">What our clients say about us</p>
                    </motion.div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {testimonials.map((testimonial, index) => (
                            <TestimonialCard key={index} {...testimonial} delay={index * 0.05} />
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Testimonials;